import React from 'react';
import '../css/styles.css';
import bgimage1 from "../img/img2.jfif";
import bgimage2 from "../img/bg4.jfif";
import bgimage3 from "../img/bg1.jpg";
import {Link} from 'react-router-dom';

const bgStyle = {
  backgroundImage: "url(" + bgimage1 + ")",
  backgroundSize: "cover",
};
const bgStyle1 = {
  backgroundImage: "url(" + bgimage2 + ")",
  backgroundSize: "cover",
};
const bgStyle2 = {
  backgroundImage: "url(" + bgimage3 + ")",
  backgroundSize: "cover",
};

export default function HomeSlider() {
  return (
    <>
       <div id="carousel" className="carousel slide" data-ride="carousel">
        <ol className="carousel-indicators">
          <li data-target="#carousel" data-slide-to="0" className="active"></li>
          <li data-target="#carousel" data-slide-to="1"></li>
          <li data-target="#carousel" data-slide-to="2"></li>
        </ol>

        <div className="carousel-inner" role="listbox">

          <div className="carousel-item active" style={bgStyle1}>
            <div className="caption" id="slide1">
              <h1>Manufacturer of Precision Engineering & Sheet Metal Components</h1>
              <h2>Shree Siddhi Vinayak Engineering has years of experience of laser engineering.</h2>
                <span  className="big-button"><Link to="/contact">Get Quote</Link></span>
              <div className="clear"></div>
            </div>
          </div>

          <div className="carousel-item" style={bgStyle}>
            <div className="caption" id="slide2">
              <h1>Manufacturing At The Speed Of Light</h1>
              <h2>Laser Cutting Company uses modern high-powered lasers for precision cutting from prototype through production.We have been providing our customers with the highest quality products, fastest service.Contact us today and your products can be manufactured at the speed of light!</h2>
            </div>
          </div>
          
          <div className="carousel-item" style={bgStyle2}>
            <div className="caption" id="slide3">
              <h1>LASER TECHNOLOGY <span className='carousel_p'>beyond imgination</span></h1>
              <h2>Without Affecting Environments Gives Perfect Outcomes.Low Pollution,Low Energy & high benefit</h2>
            </div>
          </div>

        </div>
        
        <a className="carousel-control-prev" href="#carousel" role="button" data-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#carousel" role="button" data-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>

      </div>
    </>
  )
}
